import { ref, push, set, update, remove, onValue } from 'firebase/database'
import { db, tref } from './firebase.js'
import { logActivity } from './activity.js'

// Shop tasks. /club/tasks. {id}:{title,assignedTo,dueDate,status,notes,createdAt}
const BASE = 'club/tasks'
export const TASK_STATUSES = ['To Do', 'In Progress', 'Done']

export function watchTasks(cb) { return onValue(tref(BASE), (s) => cb(s.val() || {})) }
export async function createTask(d) {
  const title = String(d.title || '').trim(); if (!title) throw new Error('Task title is required.')
  const node = push(tref(BASE))
  await set(node, { id: node.key, title, assignedTo: d.assignedTo || null, dueDate: d.dueDate || '', status: 'To Do', notes: String(d.notes || '').trim(), createdAt: Date.now() })
  logActivity({ type: 'task', icon: '✅', text: `Task added: ${title}` })
  return node.key
}
export async function updateTask(id, patch) {
  const clean = {}
  for (const k of ['title', 'dueDate', 'notes', 'status']) if (patch[k] != null) clean[k] = typeof patch[k] === 'string' ? patch[k].trim() : patch[k]
  if (patch.assignedTo !== undefined) clean.assignedTo = patch.assignedTo || null
  await update(tref(`${BASE}/${id}`), clean)
}
export async function deleteTask(id) { await remove(tref(`${BASE}/${id}`)) }
